const rooms = [
  {roomName: 'Vibranium', targetPoints: 5000}, 
  {roomName: 'Gold', targetPoints: 5000}, 
  {roomName: 'Xenon', targetPoints: 5000}, 
  {roomName: 'Mythril', targetPoints: 10000}, 
  {roomName: 'Titanium', targetPoints: 10000}, 
  {roomName: 'Adamantium', targetPoints: 10000}, 
  {roomName: 'Zinc', targetPoints: 10000}, 
  {roomName: 'Oxygen', targetPoints: 15000},
  {roomName: 'Silver', targetPoints: 15000},
  {roomName: 'Lithium', targetPoints: 15000}];

  export default rooms